import { Button } from '@/components/ui/button';
import { useAuth } from '@pooflabs/web';
import { ArrowRight } from 'lucide-react';
import React from 'react';
import { toast } from 'sonner';

export const FinalCta: React.FC = () => {
  const { login } = useAuth();

  const handleAuth = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Failed to login', error);
      toast.error('Could not open wallet login. Please try again.');
    }
  };

  return (
    <section className='py-20 sm:py-28'>
      <div className='container'>
        <div className='relative overflow-hidden rounded-2xl border border-border bg-primary px-8 py-14 text-center sm:px-16'>
          <div className='pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-white/10 blur-3xl' />
          <div className='pointer-events-none absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-white/10 blur-3xl' />

          <h2 className='font-heading relative z-10 text-3xl font-bold tracking-tight text-primary-foreground sm:text-4xl'>
            Start selling to FUTO, the trusted way.
          </h2>
          <p className='relative z-10 mx-auto mt-3 max-w-md text-sm text-primary-foreground/85 sm:text-base'>
            Get verified once. Sell to every student on campus, with a badge
            that says buyers can trust you.
          </p>

          <Button
            size='lg'
            onClick={handleAuth}
            className='relative z-10 mt-8 gap-2 rounded-full bg-white px-7 text-base text-primary hover:bg-white/90'
          >
            Start selling
            <ArrowRight className='h-4 w-4' />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
